<app-modal-main class="financing-calculator-modal">
  <app-modal-main-content>
    <app-modal-header>
      <app-modal-title>{{ 'modals.financingCalculator.title' | translate }}</app-modal-title>
      <app-paragraph [font-size]="'small'">
        {{ 'modals.financingCalculator.description' | translate }}<br />
        {{ 'modals.financingCalculator.description2' | translate }}
      </app-paragraph>
    </app-modal-header>
    @if (data) {
      <app-financing-calculator-form
        [type]="data.type === 'online' ? 'online-modal' : 'financing-modal'"
        [car-id]="data.id"
        [car-price]="data.price"
        [active-advance]="advance"
        [active-months]="months"
        [active-loan-type]="loanType"
        [car-payment-options]="data.paymentOptions"
        (data-changed)="dataChanged($event)"
      ></app-financing-calculator-form>
    }
  </app-modal-main-content>
</app-modal-main>
